import React from 'react';
import PropTypes from 'prop-types';
import EditableTitle from '../../EditableTitle';
import * as styles from './style';
import { FONT_SIZE_7 } from '../../../styles/variables';
import withCreateProductAddons from '../../../containers/CreateProductsAddons';
import { PRODUCT_ADDONS } from '../../../helpers/constants';

const removeAddon = ({ step, currentIndex, lastIndex, removeAddonStep, goToSlide }) => {
  if (currentIndex >= lastIndex - 2) {
    const index = currentIndex === lastIndex ? currentIndex - 2 : currentIndex - 1;

    goToSlide(index);
  }

  removeAddonStep(step.id);
};

const getTitleComponent = (step, editStepTitle, order) => {
  switch (step.addonType) {
    case PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS:
      return <styles.Title className="read-title-variation">{step.data.title}</styles.Title>;
    case PRODUCT_ADDONS.SELECTED_PRODUCTS:
      return (
        <EditableTitle
          id={`title-combo-${order}`}
          iconEditColor="rgba(255, 255, 255, 0.8)"
          iconCloseColor="rgba(255, 255, 255, 0.8)"
          iconEditSize="24px"
          width="100%"
          height="25px"
          noMargin
          placeholder="Digite o titulo do Passo"
          onChange={e => editStepTitle(step.id, e.target.value)}
          title={step.title}
          fontSize={FONT_SIZE_7}
          fontColor="#FFF"
        />
      );
    default:
      return null;
  }
};

const StepHeader = ({
  step,
  order,
  editStepTitle,
  removeAddonStep,
  goToSlide,
  currentIndex,
  lastIndex,
}) => {
  return (
    <styles.Container>
      <styles.Content>
        <styles.StepContainer>
          <styles.Step className="step-number">{order}º Passo</styles.Step>
          {order !== 1 && (
            <styles.RemoveStep
              onClick={() =>
                removeAddon({
                  step,
                  currentIndex,
                  lastIndex,
                  removeAddonStep,
                  goToSlide,
                })
              }
              className="btn-remove-step"
            >
              Excluir Passo
            </styles.RemoveStep>
          )}
        </styles.StepContainer>

        {getTitleComponent(step, editStepTitle, order)}
      </styles.Content>
    </styles.Container>
  );
};

StepHeader.propTypes = {
  step: PropTypes.object.isRequired,
  order: PropTypes.number.isRequired,
  editStepTitle: PropTypes.func.isRequired,
};

export default withCreateProductAddons(StepHeader);



// WEBPACK FOOTER //
// ./src/components/ProductAddons/StepHeader/index.js